<template>
  <div class="inline-block">
    <DropDownAbsolute v-model="opened">
      <div class="hvh-flex">
        <v-btn flat class="hvh-btn hvh-btn--secondary my-0 mx-0" @click="$emit('click', $event)">Export results</v-btn>
        <div flat class="hvh-btn hvh-btn--secondary my-0 mx-0 theme--light hvh-flex align-center clickable" @click.stop="opened = !opened">
          <v-icon>mdi-menu-down</v-icon>
        </div>
      </div>
      <template #drop-down>
        <div class="py-3">
          <template v-if="!isLoading">
            <div class="clickable px-3" @click="goTo(`/Analytics/CohortAnalyticRun/${runId}/Result`)" v-if="numOfAnalytics">Export History ({{ numOfAnalytics }})</div>
            <div class="px-3" v-else>No previous exports</div>
          </template>
          <LoaderLinear v-else />
        </div>
      </template>
    </DropDownAbsolute>
  </div>
</template>


<script>
import DropDownAbsolute from '../../../common/dropDown/DropDownAbsolute.vue'
import LoaderLinear from '../../../common/loader/LoaderLinear.vue';

export default {
  components: { DropDownAbsolute, LoaderLinear },
  props: ['runId', 'numOfAnalytics', 'isLoading'],
  data() {
    return {
      opened: false
    };
  },
}
</script>